// import PropTypes from 'prop-types',
import React from 'react'
import PropTypes from 'prop-types'
import FormikControl from '../../../molecules/FormikControl'
import ContractExtrasTable from '../../../molecules/contractExtras/ContractExtrasTable'
import eventBus from '../../../../lib/eventBus'
import { useFormik } from 'formik'
import makeStyles from '@mui/styles/makeStyles'
import { refreshFilter } from '../../../../lib/handleFilters'
import {
  DialogActions,
  Button,
  DialogContent,
  Grid,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  IconButton,
  FormControl,
  TextField,
} from '@mui/material'
import Search from '../../../molecules/Search'
import { Add, Clear, List, Create } from '@mui/icons-material'
import SaveIcon from '@mui/icons-material/Save'
import * as Yup from 'yup'
import axios from 'axios'
import { handleOpenAlert } from '../../../../lib/handleAlert'
import { closePopup } from '../../../../store/popupsSlice'
import { useDispatch } from 'react-redux'
import FormikSelect from '../../../molecules/FormikSelect'
import { useEffect, useState } from 'react'
import ExaminationsTable from '../../../molecules/examinationsTable/ExaminationsTable'
import { openPopup } from '../../../../store/popupsSlice'
import Confirmation from '../Confirmation'
import LoadingButton from '@mui/lab/LoadingButton'

const useStyles = makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,
  },
  root: {
    maxHeight: '800px',
  },
  bef: {
    display: 'none',
  },
  [theme.breakpoints.between('xs', 'md')]: {
    root: {
      display: 'none',
    },
    footer_none: {
      display: 'none',
    },
    bef: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: '900',
      height: '100%',
      fontSize: '24px',
      textAlign: 'center',
    },
    form: {
      height: '300px',
    },
  },
}))

const parseExaminations = (examinations) => {
  let result = {}
  let types = Object.keys(examinations)
  for (let i = 0; i < types.length; i++) {
    let type = types[i]
    let examKeys = Object.keys(examinations[type])
    result[type] = []
    for (let j = 0; j < examKeys.length; j++) {
      let examKey = examKeys[j]
      result[type].push({ tooth1: null, ...examinations[type][examKey] })
    }
  }
  return result
}

const parseExtras = (extras) => {
  let result = []
  let extrasKeys = Object.keys(extras)
  for (let i = 0; i < extrasKeys.length; i++) {
    result.push(extras[extrasKeys[i]])
  }

  return result
}

const parseValues = (values, ourDoctor, OurMedicalName) => {
  let result = { ...values }
  delete result.newExaminationType
  delete result.examinations
  delete result.extras
  result.components = parseExaminations(values.examinations)
  result.extras = parseExtras(values.extras)
  if (ourDoctor) {
    delete result.doctor_name
  } else {
    delete result.doctor_id
  }
  if (OurMedicalName) {
    delete result.medical_care_name
  } else {
    delete result.medical_care_id
  }
  return result
}

let errorExams = ''

const ContractFactory = ({ ...values }) => {
  const id = values.id
  const finalizeFlag = values.finalize
  const eventFlag = values.event
  const [sweetAlert, setSweetAlert] = useState(false)

  const classes = useStyles()

  const dispatch = useDispatch()

  const [ourDoctor, setOurDoctor] = useState(values.doctor_id || !values.id)
  const [ourMedicalName, setOurMedicalName] = useState(true)

  const [examinationTypes, setExaminationTypes] = useState([])
  const [doctors, setDoctors] = useState([])
  const [contractTypes, setContractTypes] = useState([])
  const [admins, setAdmins] = useState([])
  const [medicalFacilities, setMedicalFacilities] = useState([])
  const [medical_care, setMedicalCare] = useState([])
  const [examinations, setExaminations] = useState([])
  const [extras, setExtras] = useState([])
  const [loaded, setLoaded] = useState(false)
  const [refresh, setRefresh] = useState(1)
  const [validate, setValidate] = useState(false)
  const [events, _setEvents] = useState(false)
  const [files, setFiles] = useState({})
  const [intervalValue, setIntervalValue] = useState(null)
  const [autoSelectedFiles, setAutoSelectedFilles] = useState([])
  const [eventsCount, setEventsCount] = useState({})
  const [componentByRomexisId, setComponentByRomexisId] = useState({})
  const [loading, setLoading] = useState(false)
  // const [examinationByTypeId, setEexaminationByTypeId] = useState({})
  // const [filteredFiles, setFilteredFiles] = useState([])

  const [summaryGross, setSummaryGross] = useState()

  const [patientName, setPatientName] = useState(
    values ? `${values.firstname} ${values.lastname}` : null
  )
  const [patientId, setPatientId] = useState(values ? values.patient_id : null)

  const formik = useFormik({
    initialValues: {
      patient_id: values.patient_id,
      doctor_id: values.doctor_id,
      doctor_name: values.doctor_name,
      user_id: values.user_id || '',
      medical_facility_id: values.medical_facility_id,
      internal: values.internal,
      type_id: values.type_id,
      medical_care_id: values.medical_care_id,
      contract_id: values.id,
      newExaminationType: null,
      examinations: {},
      extras: {},
    },
    enableReinitialize: false,
    validationSchema: Yup.object({
      user_id: Yup.string().test(
        'required',
        'Pole wymagane',
        (val) => (!val && !finalizeFlag) || val
      ),
      patient_id: Yup.string().required('Pole wymagane').nullable(),
      doctor_name: !ourDoctor && Yup.string().required('Pole wymagane'),
      doctor_id: ourDoctor && Yup.string().required('Pole wymagane'),
      type_id: eventFlag && Yup.string().required('Pole wymagane'),
      medical_care_name:
        !ourMedicalName && Yup.string().required('Pole wymagane'),
      medical_care_id: ourMedicalName && Yup.string().required('Pole wymagane'),
      examinations: Yup.object().test(
        'exams-test',
        errorExams,
        function (value) {
          return value['1'] || value['2'] || value['3'] || value['4']
        }
      ),
      // medical_facility_id:
      // medicalFacilityRequired && Yup.string().required('Pole wymagane'),
    }),
    onSubmit: async (values) => {
      // @PATRYK onsubmit teraz przeprowadza tylko dodatkowa walidacje (tak tez bylo wczesniej) po czym odpala popupa
      setLoading(true)
      let elements = await document.querySelector('.Mui-error')
      if (!elements) {
        if (events.length > 0 || Object.keys(eventsCount).length > 0) {
          let localValues = parseValues(
            values,
            ourDoctor,
            ourMedicalName,
            sweetAlert
          )

          dispatch(
            openPopup({
              component: 'EventsFactory',
              title: 'Oznacz błędne zdjęcia',
              level: 2,
              key: 'events-factory-popup',
              values: {
                startFiles: events,
                eventsCount: eventsCount,
                data: { ...localValues, id },
                examinations,
                allFiles: files,
              },
            })
          )
          setLoading(false)
        } else {
          setSweetAlert(true)
        }
      } else {
        setLoading(false)
      }
    },
  })

  const addEventsCount = (type, id, value) => {
    let eCount = Object.assign({}, eventsCount)
    if (value == 0) {
      if (eCount[id]) {
        delete eCount[id]
      }
    } else {
      eCount[id] = {
        examination_id: formik.values.examinations[type][id].examination_id,
        value: value,
      }
    }
    setEventsCount(eCount)
  }

  useEffect(async () => {
    await setExaminationTypes(await loadExaminationTypes())
    await setDoctors(await loadDoctors())
    await setAdmins(await loadAdmins())
    await setMedicalFacilities(await loadMedicalFacilities())
    await setMedicalCare(await loadMedicalCare())
    await setExaminations(await loadExaminations())
    await setExtras(await loadExtras())
    await setContractTypes(await loadContractTypes())
    if (id) {
      await loadContract(id)
    }
    if (values.firstname && values.lastname && values.patient_id) {
      setPatientName(`${values.firstname} ${values.lastname}`)
      await formik.setFieldValue('patient_id', values.patient_id)
    }
    setRefresh(refresh + 1)
    setLoaded(true)
  }, [])

  useEffect(() => {
    eventBus.on('refreshPatient', (data) => {
      refreshPatientFunc(data.patient_id)
    })

    return eventBus.remove('refreshPatient')
  }, [])
  useEffect(() => {
    eventBus.on('refreshExaminationFile', () => {
      loadContract(id)
    })

    return eventBus.remove('refreshExaminationFile')
  }, [])

  // useEffect(() => {
  //   eventBus.on('calculateNewPatient', (data) => {
  //     handleRowChange(data.examination_id, 'examination_id', 1, data.keyString)
  //   })

  //   return eventBus.remove('calculateNewPatient')
  // }, [])

  useEffect(() => {
    eventBus.on('popupClosed', ({ key }) => {
      if (key == 'patient-factory-popup') {
        deletePatient()
      }
    })

    return eventBus.remove('popupClosed')
  }, [])

  const parseComponents = (components) => {
    let result = {}

    for (let i = 0; i < components.length; i++) {
      let component = components[i]
      if (!result[component.type_id]) {
        result[component.type_id] = {}
      }
      Object.assign(result[component.type_id], {
        [component.id]: {
          ...component.object,
          id: component.id,
          price_gross: component.price_gross,
          examination_id: component.examination_id,
          photo_name: component.photo_name,
          examination_name: component.examination_name,
          photo_dap: component.photo_dap,
          comment: component.comment,
          romexis_id: component.romexis_id,
          tooth1: component.tooth1,
          tooth2: component.tooth2,
        },
      })
    }

    calculate(result)
    return result
  }

  const loadExaminationTypes = () => {
    return new Promise(function (resolve) {
      axios.post('/lookups/examination_types').then((res) => {
        if (res.status == 200) {
          resolve(res.data)
        }
      })
    })
  }

  const loadExtras = () => {
    return new Promise(function (resolve) {
      axios.post('/lookups/extras').then((res) => {
        if (res.status == 200) {
          resolve(res.data)
        }
      })
    })
  }

  const loadContractTypes = () => {
    return new Promise(function (resolve) {
      axios.post('/lookups/contract_types', null).then((res) => {
        resolve(res.data)
      })
    })
  }

  const loadExaminations = () => {
    return new Promise(function (resolve) {
      axios.post('/lookups/examinations').then((res) => {
        if (res.status == 200) {
          resolve(res.data)
        }
      })
    })
  }

  const loadMedicalFacilities = () => {
    return new Promise(function (resolve) {
      axios.post('/lookups/medical_facilities').then((res) => {
        if (res.status == 200) {
          resolve(res.data)
        }
      })
    })
  }

  const loadMedicalCare = () => {
    return new Promise(function (resolve) {
      axios.post('/lookups/medical_care').then((res) => {
        if (res.status == 200) {
          resolve(res.data)
        }
      })
    })
  }

  const loadDoctors = () => {
    return new Promise(function (resolve) {
      axios
        .post('/lookups/doctors', { doctor_id: values.doctor_id })
        .then((res) => {
          if (res.status == 200) {
            resolve(res.data)
          }
        })
    })
  }

  const loadAdmins = () => {
    return new Promise(function (resolve) {
      axios.post('/admins').then((res) => {
        if (res.status == 200) {
          resolve(res.data)
        }
      })
    })
  }

  const handlePatientChange = (formik, value, name) => {
    if (formik.values.patient_id !== value.id) {
      formik.setFieldValue('patient_id', value.id)
      setPatientId(value.id)
      setPatientName(name)
      if (!validatePatient(value)) {
        if (value.id) {
          handleOpenAlert({
            title: 'Uwaga!',
            subtitle: `Należy uzupełnić brakujące dane`,
            type: 'warning',
          })
        } else {
          handleOpenAlert({
            title: 'Pacjent z zewnętrznego systemu',
            subtitle: `Należy uzupełnić brakujące dane`,
            type: 'warning',
          })
        }
        dispatch(
          openPopup({
            component: 'PatientFactory',
            title: 'Edytuj pacjenta',
            level: 2,
            values: {
              ...value,
            },
            key: 'patient-factory-popup',
          })
        )
      }
    }
  }

  useEffect(() => {
    if (
      formik.values.examinations &&
      Object.keys(formik.values.examinations).length > 0
    )
      refreshExaminations()
  }, [patientId])

  const refreshExaminations = () => {
    let temp = JSON.parse(JSON.stringify(formik.values.examinations))
    let examsKeys = Object.keys(temp['1'])
    for (let j = 0; j < examsKeys.length; j++) {
      let examsKey = examsKeys[j]
      handleRowChange(
        temp['1'][examsKey].examination_id,
        'examination_id',
        1,
        examsKey
      )
    }
  }

  const refreshPatientFunc = (id) => {
    if (id) {
      axios
        .post(`/patients/${id}`)
        .then((res) => {
          handlePatientChange(
            formik,
            res.data,
            `${res.data.firstname} ${res.data.lastname}`
          )
        })
        .catch((err) => {
          handleOpenAlert(err.request.status)
        })
    }
  }

  const deletePatient = () => {
    formik.setFieldValue('patient_id', null)
    setPatientName('')
  }

  const validatePatient = (patient) => {
    let valid =
      patient.firstname &&
      patient.lastname &&
      patient.birth_date &&
      patient.gender_id

    if (patient.active && valid) {
      valid = patient.phone_number || patient.email
    }

    return true
  }

  const loadContract = (id) => {
    axios.post(`/contracts/${id}`).then(async (res) => {
      if (res.status == 200) {
        if (res.data.doctor_name && res.data.medical_care_name) {
          setOurDoctor(false)
          setOurMedicalName(false)
        }
        await formik.setFieldValue('status_id', res.data.status_id)
        await formik.setFieldValue(
          'examinations',
          parseComponents(res.data.components)
        )
      }
    })
  }

  useEffect(async () => {
    if (formik && values.patient_id && values.patient_name) {
      setPatientName(values.patient_name)
    }
  }, [formik, values])

  useEffect(async () => {
    setEvents()
  }, [files, componentByRomexisId])

  const store = (values) => {
    axios
      .post('/contracts/store', {
        ...values,
      })
      .then((res) => {
        if (res.status == 200) {
          dispatch(closePopup('contract-factory-popup'))
          refreshFilter('ContractsKey')
        }
        setLoading(false)
        handleOpenAlert({
          title: 'Sukces!',
          subtitle: finalizeFlag
            ? 'Sfinalizowano zlecenie!'
            : 'Dodano zlecenie!',
          type: 'success',
        })
      })
      .catch((err) => {
        handleOpenAlert(err.request.status)
        setLoading(false)
      })
  }

  const edit = (values) => {
    axios
      .post(`/contracts/${id}/edit`, {
        ...values,
      })
      .then((res) => {
        if (res.status == 200) {
          dispatch(closePopup('contract-factory-popup'))
          refreshFilter('ContractsKey')
        }
        setLoading(false)
        handleOpenAlert({
          title: 'Sukces!',
          subtitle: 'Edytowano zlecenie!',
          type: 'success',
        })
      })
      .catch((err) => {
        handleOpenAlert(err.request.status)
        setLoading(false)
      })
  }

  const finalize = (values) => {
    axios
      .post(`/contracts/${id}/finish`, {
        ...values,
      })
      .then((res) => {
        if (res.status == 200) {
          dispatch(closePopup('contract-factory-popup'))
          refreshFilter('ContractsKey')
        }
        setLoading(false)
        handleOpenAlert({
          title: 'Sukces!',
          subtitle: 'Sfinalizowano zlecenie!',
          type: 'success',
        })
      })
      .catch((err) => {
        handleOpenAlert(err.request.status)
        setLoading(false)
      })
  }

  // const handleChangeCheckBox = (formik, value, name) => {
  //   formik.setFieldValue(name, value)
  // }

  const getFiles = (type, componentId) => {
    let f = []
    if (files[type]) {
      for (let i = 0; i < files[type].length; i++) {
        let component = findComponent(type, files[type][i].romexis_id)
        if (
          (!files[type][i].component_id ||
            files[type][i].component_id == componentId) &&
          (!component || component == componentId)
        ) {
          f.push(files[type][i])
        }
      }
    }
    return f
  }

  const addType = (type) => {
    let temp = JSON.parse(JSON.stringify(formik.values.examinations))
    temp[type] = temp[type] ? temp[type] : {}
    Object.assign(temp[type], { [Math.random()]: {} })
    formik.setFieldValue('examinations', temp)
  }

  const addExtra = () => {
    let temp = JSON.parse(JSON.stringify(formik.values.extras))
    Object.assign(temp, { [Math.random()]: { quantity: 1 } })
    formik.setFieldValue('extras', temp)
  }

  const setEvents = () => {
    let f = []
    for (let i = 2; i <= 4; i++) {
      if (files[i]) {
        for (let j = 0; j < files[i].length; j++) {
          if (
            !files[i][j].component_id &&
            !findComponent(i, files[i][j].romexis_id)
          ) {
            // let object = Object.assign(files[i][j])
            // object.type = i
            f.push(files[i][j])
          }
        }
      }
    }
    _setEvents(f)
  }

  const addAutoSelectedFile = (romexisId) => {
    let array = autoSelectedFiles
    array.push(romexisId)
    setAutoSelectedFilles(array)
  }

  const handleFiles = () => {
    axios
      .post(`/contracts/${formik.values.contract_id}/photos`, null)
      .then((res) => {
        let files = res.data
        setFiles(files)
        for (let i = 2; i <= 4; i++) {
          if (!files[i]) {
            continue
          }
          for (let j = 0; j < files[i].length; j++) {
            let file = files[i][j]
            if (file.component_id) {
              addUsedFile(i, file, file.component_id, true)
            }
          }
          if (formik.values.examinations[i]) {
            let keys = Object.keys(formik.values.examinations[i])
            // console.log(
            //   files[i].length,
            //   keys.length,
            //   files[i].length === 1 && keys.length === 1
            // )
            if (files[i].length === 1 && keys.length === 1) {
              let f = files[i][0]
              if (
                autoSelectedFiles.indexOf(f.romexis_id) === -1 &&
                !f.component_id
              ) {
                addAutoSelectedFile(f.romexis_id)
                addUsedFile(i, f, keys.pop())
              }
              // console.log(i, files[i][0], keys.pop())
            }
          }
        }
        // console.log(files)
      })
  }

  const addUsedFile = async (type, file, id, disabled = false) => {
    id = String(id)
    type = Number(type)
    // let used = usedFiles
    // used[type][file.component_id] = {
    //   romexis_id: file.romexis_id,
    //   disabled: disabled,
    //   dap: file.dap,
    // }
    let object = Object.assign({}, componentByRomexisId)
    let keys = Object.keys(object)
    for (let i = 0; i < keys.length; i++) {
      if (object[keys[i]] === id) {
        object[keys[i]] = null
        break
      }
    }
    if (file.romexis_id) {
      object[file.romexis_id] = id
    }
    setComponentByRomexisId(object)

    handleRowChangeMany(
      [
        { value: disabled, variable: 'disabled_romexis' },
        { value: file.dap, variable: 'dap' },
        { value: file.romexis_id, variable: 'romexis_id' },
      ],
      type,
      id
    )
    // setUsedFiles(used)
  }
  //eslint-disable-next-line
  const findFile = (type,romexisId) => {
    if (files[type]) {
      for (let i = 0; i < files[type].length; i++) {
        if (files[type][i].romexis_id == romexisId) {
          return files[type][i]
        }
      }
    }
    return null
  }
  const findComponent = (type, romexisId) => {
    return componentByRomexisId[romexisId] || null
    // let components = formik.values.examinations[type] || {}
    // let keys = Object.keys(components)
    // for (let i = 0; i < keys.length; i++) {
    //   let component = Object.assign({}, components[keys[i]])
    //   if (component.romexis_id == romexisId) {
    //     component.id = keys[i]
    //     return component
    //   }
    // }
    // return null
  }
  const assignFileToComponent = (type, componentId, romexisId) => {
    // let file = null
    if (romexisId) {
      let file = findFile(type, romexisId)
      if (file) {
        addUsedFile(type, file, componentId)
      }
    } else {
      addUsedFile(type, {}, componentId)
    }
  }

  const handleRowChange = async (
    value,
    variable,
    type,
    keyString,
    object = 'examinations'
  ) => {
    if (variable == 'count') {
      addEventsCount(type, keyString, value)
    }
    let temp = JSON.parse(JSON.stringify(formik.values[object]))
    if (object == 'examinations') {
      temp[type][keyString][variable] = value
    } else {
      temp[keyString][variable] = value
    }

    if (variable == 'examination_id' && type == 1) {
      await generateRowValues(value, type, keyString)
    } else if (
      type !== 1 &&
      object !== 'extras' &&
      variable == 'examination_id'
    ) {
      temp[type][keyString].price_gross = formik.values.internal
        ? 0
        : await getPrice(type, value)
    } else if (
      variable == 'extra_id' &&
      object === 'extras' &&
      variable == 'extra_id'
    ) {
      temp[keyString].price_gross = await getExtraPrice(value)
    }

    await formik.setFieldValue(object, temp)
    if (object == 'examinations') {
      calculate(temp)
    } else {
      calculate(JSON.parse(JSON.stringify(formik.values.examinations)), temp)
    }
  }
  const handleRowChangeMany = async (
    array,
    type,
    keyString,
    object = 'examinations'
  ) => {
    let temp = JSON.parse(JSON.stringify(formik.values[object]))
    if (!temp[type]) {
      return
    }
    for (let i = 0; i < array.length; i++) {
      let value = array[i].value
      let variable = array[i].variable
      if (object == 'examinations') {
        temp[type][keyString][variable] = value
      } else {
        temp[keyString][variable] = value
      }

      if (variable == 'examination_id' && type == 1) {
        await generateRowValues(value, type, keyString)
      } else if (
        type !== 1 &&
        object !== 'extras' &&
        variable == 'examination_id'
      ) {
        temp[type][keyString].price_gross = formik.values.internal
          ? 0
          : await getPrice(type, value)
      } else if (
        variable == 'extra_id' &&
        object === 'extras' &&
        variable == 'extra_id'
      ) {
        temp[keyString].price_gross = await getExtraPrice(value)
      }
    }

    await formik.setFieldValue(object, temp)
    if (object == 'examinations') {
      calculate(temp)
    } else {
      calculate(JSON.parse(JSON.stringify(formik.values.examinations)), temp)
    }
  }

  const findExamination = (arr, id) => {
    return new Promise(function (resolve) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === id) {
          resolve(i)
        }
      }
      resolve(0)
    })
  }

  const getPrice = async (type, examination) => {
    // eslint-disable-next-line
    return new Promise(async function (resolve) {
      resolve(
        examinations[type][
          await findExamination(examinations[type], examination)
        ].price_gross
      )
    })
  }

  const getExtraPrice = async (extra) => {
    // eslint-disable-next-line
    return new Promise(async function (resolve) {
      resolve(extras[await findExamination(extras, extra)].price_gross)
    })
  }

  const generateRowValues = (examination, type, keyString) => {
    axios
      .post('/examinations/calculate', {
        examination_id: examination,
        patient_id: formik.values.patient_id,
      })
      .then(async (res) => {
        if (res.status == 200) {
          let temp = JSON.parse(JSON.stringify(formik.values.examinations))
          temp[type][keyString] = {
            ...res.data,
            examination_id: examination,
            tooth1: temp[type][keyString].tooth1,
          }
          temp[type][keyString].price_gross = formik.values.internal
            ? 0
            : await getPrice(type, examination)
          formik.setFieldValue('examinations', temp)
          calculate(temp)
        }
      })
  }

  const deleteRow = async (type, keyString) => {
    let temp = JSON.parse(JSON.stringify(formik.values.examinations))
    delete temp[type][keyString]
    await formik.setFieldValue('examinations', temp)
    if (edit) {
      let editDel = Object.assign([], formik.values.editDel)
      editDel.push(keyString)
      await formik.setFieldValue('editDel', editDel)
    }
    calculate(temp)
  }
  const editFile = async (type, keyString) => {
    dispatch(
      openPopup({
        component: 'ExaminationFileEdit',
        title: 'Zmień zdjęcie',
        level: 2,
        key: 'examination-file-edit-popup',
        values: {
          id: keyString,
          type,
          romexisId: formik.values.examinations[type][keyString].romexis_id,
        },
      })
    )
  }

  const deleteExtraRow = async (type, keyString) => {
    let temp = JSON.parse(JSON.stringify(formik.values.extras))
    delete temp[keyString]
    await formik.setFieldValue('extras', temp)
    calculate(JSON.parse(JSON.stringify(formik.values.examinations)), temp)
  }

  const handleInternalChange = (formik, value) => {
    formik.setFieldValue('internal', value)
    if (value) {
      clearPrices()
    }
  }

  const clearPrices = () => {
    let extrasL = JSON.parse(JSON.stringify(formik.values.extras))
    let examinationsL = JSON.parse(JSON.stringify(formik.values.examinations))
    const examinationsTypes = Object.keys(examinationsL)
    const extrasKeys = Object.keys(extrasL)

    for (let i = 0; i < examinationsTypes.length; i++) {
      const examsInType = examinationsL[examinationsTypes[i]]
      if (examsInType) {
        const examsInTypeKeys = Object.keys(examsInType)
        for (let j = 0; j < examsInTypeKeys.length; j++) {
          examinationsL[examinationsTypes[i]][
            examsInTypeKeys[j]
          ].price_gross = 0
        }
      }
    }

    for (let i = 0; i < extrasKeys.length; i++) {
      extrasL[extrasKeys[i]].price_gross = 0
    }

    formik.setFieldValue('examinations', examinationsL)
    formik.setFieldValue('extras', extrasL)
    calculate(examinationsL, extrasL)
  }

  const calculate = (
    exams,
    extra = JSON.parse(JSON.stringify(formik.values.extras))
  ) => {
    const examinations = exams
    const extras = extra

    const examinationsTypesKeys = Object.keys(examinations)
    const extrasKeys = Object.keys(extras)

    let result = 0

    for (let i = 0; i < examinationsTypesKeys.length; i++) {
      const examinationsType = examinationsTypesKeys[i]
      const examinationsByTypeKeys = Object.keys(examinations[examinationsType])

      for (let j = 0; j < examinationsByTypeKeys.length; j++) {
        const examination =
          examinations[examinationsTypesKeys[i]][examinationsByTypeKeys[j]]
        result += examination.price_gross ? Number(examination.price_gross) : 0
      }
    }

    for (let i = 0; i < extrasKeys.length; i++) {
      const extraKey = extrasKeys[i]
      const extraL = extras[extraKey]

      result += Number(extraL.price_gross) * extraL.quantity
    }

    setSummaryGross(result)
  }
  if (finalizeFlag) {
    useEffect(() => {
      let iValue = null
      if (
        !intervalValue &&
        Object.keys(formik.values.examinations).length > 0
      ) {
        handleFiles()
        let iValue = setInterval(handleFiles, 10000)
        setIntervalValue(iValue)
      }
      return () => clearInterval(iValue)
    }, [formik.values.examinations])
    useEffect(() => {
      return () => clearInterval(intervalValue)
    }, [intervalValue])
  }

  return (
    <>
      {formik && loaded && (
        <form
          onSubmit={formik.handleSubmit}
          onReset={formik.handleReset}
          className={classes.form}
        >
          <p className={classes.bef}>
            Dodawanie/Edycja zleceń dostępne tylko w wersji desktopowej
          </p>
          <DialogContent dividers={true} className={classes.root}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                {/* {eventFlag && (
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" component="div">
                      Dane zdarzenia
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <FormikSelect
                      variableName="type_id"
                      handleChange={formik.handleChange}
                      value={formik.values['type_id']}
                      labelName="Typ"
                      formik={formik}
                      options={contractTypes}
                    />
                  </Grid>
                </Grid>
              )} */}
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" component="div">
                      Dane administracyjne
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Grid
                      key={formik.values.patient_id}
                      container
                      spacing={0}
                      direction="row"
                      wrap="nowrap"
                      alignItems="center"
                    >
                      <Grid item xs={12}>
                        {refresh &&
                        (formik.values.patient_id || values.patient_id) &&
                        patientName ? (
                          <FormControl fullWidth>
                            <TextField
                              disabled={finalizeFlag}
                              label="Pacjent"
                              type="text"
                              value={patientName}
                              variant="outlined"
                              error={
                                formik.touched.patient_id &&
                                Boolean(formik.errors.patient_id)
                              }
                              helperText={
                                formik.touched.patient_id &&
                                formik.errors.patient_id
                              }
                            />
                          </FormControl>
                        ) : (
                          <Search
                            error={
                              formik.touched.patient_id &&
                              Boolean(formik.errors.patient_id)
                            }
                            helperText={
                              formik.touched.patient_id &&
                              formik.errors.patient_id
                            }
                            disabled={finalizeFlag}
                            emitValue={(value, name) => {
                              handlePatientChange(formik, value, name)
                            }}
                            wholeObject={true}
                          />
                        )}
                      </Grid>
                      {!values.patient_id || values.patientEditable
                        ? !finalizeFlag &&
                          (formik.values.patient_id && patientName ? (
                            <IconButton
                              color="secondary"
                              component="span"
                              onClick={() => {
                                deletePatient()
                              }}
                              size="large"
                            >
                              <Clear />
                            </IconButton>
                          ) : (
                            <IconButton
                              color="primary"
                              component="span"
                              size="large"
                              onClick={() =>
                                dispatch(
                                  openPopup({
                                    component: 'PatientFactory',
                                    title: 'Dodaj pacjenta',
                                    level: 2,
                                    key: 'patient-factory-popup',
                                    values: {
                                      fromContract: true,
                                    },
                                  })
                                )
                              }
                            >
                              <Add />
                            </IconButton>
                          ))
                        : null}
                    </Grid>
                  </Grid>
                  <Grid item xs={3}>
                    <Grid
                      container
                      spacing={0}
                      direction="row"
                      wrap="nowrap"
                      alignItems="center"
                    >
                      {ourDoctor && loaded ? (
                        <>
                          <Grid item xs={12}>
                            <FormikSelect
                              disabled={finalizeFlag}
                              variableName="doctor_id"
                              value={formik.values['doctor_id']}
                              labelName="Lekarz"
                              formik={formik}
                              options={doctors}
                              config={{
                                key: 'id',
                                label: 'firstname+lastname',
                              }}
                            />
                          </Grid>
                          {!finalizeFlag && (
                            <IconButton
                              component="span"
                              onClick={() => {
                                setOurDoctor(false)
                              }}
                              size="large"
                            >
                              <Create />
                            </IconButton>
                          )}
                        </>
                      ) : (
                        <>
                          <Grid item xs={12}>
                            <FormikControl
                              disabled={finalizeFlag}
                              variableName="doctor_name"
                              handleChange={formik.handleChange}
                              labelName="Lekarz"
                              formik={formik}
                            />
                          </Grid>
                          {!finalizeFlag && (
                            <IconButton
                              component="span"
                              onClick={() => {
                                setOurDoctor(true)
                              }}
                              size="large"
                            >
                              <List />
                            </IconButton>
                          )}
                        </>
                      )}
                    </Grid>
                  </Grid>
                  <Grid item xs={3}>
                    {loaded && (
                      <FormikSelect
                        variableName="user_id"
                        value={formik.values['user_id']}
                        labelName="Administrator"
                        formik={formik}
                        config={{
                          key: 'id',
                          label: 'firstname+lastname',
                        }}
                        options={admins}
                      />
                    )}
                  </Grid>
                  <Grid item xs={3}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            checked={Boolean(formik.values.internal)}
                          />
                        }
                        disabled={finalizeFlag}
                        checked={Boolean(formik.values.internal)}
                        label="Zlecenie wewnętrzne"
                        onChange={(e) =>
                          handleInternalChange(formik, e.target.checked)
                        }
                        formik={formik}
                      />
                    </FormGroup>
                  </Grid>
                  {ourMedicalName ? (
                    <>
                      <Grid item xs={3}>
                        <FormikSelect
                          key={formik.values.medical_care_id}
                          variableName="medical_care_id"
                          value={formik.values['medical_care_id']}
                          labelName="Opieka medyczna"
                          formik={formik}
                          options={medical_care}
                        />
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid item xs={3}>
                        <FormikControl
                          variableName="medical_care_name"
                          handleChange={formik.handleChange}
                          labelName="Opieka medyczna"
                          formik={formik}
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={9}>
                    <FormikSelect
                      variableName="medical_facility_id"
                      value={formik.values['medical_facility_id']}
                      labelName="Placówka medyczna"
                      formik={formik}
                      config={{
                        key: 'id',
                        label: 'name+address+nip',
                        separator: ' - ',
                      }}
                      options={medicalFacilities}
                    />
                  </Grid>
                  {eventFlag && (
                    <Grid item xs={3}>
                      <FormikSelect
                        variableName="type_id"
                        value={formik.values['type_id']}
                        labelName="Typ zdarzenia"
                        formik={formik}
                        options={contractTypes}
                        // helperText="‌‌ "
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
              {!id || (!finalizeFlag && formik.values.status_id == 1) ? (
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="subtitle1" component="div">
                        Dodaj badanie
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={4}>
                          <FormikSelect
                            value={formik.values['newExaminationType']}
                            variableName="newExaminationType"
                            disabled={
                              !(formik.values.patient_id && patientName !== '')
                            }
                            labelName="Badanie"
                            formik={formik}
                            options={examinationTypes}
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <Button
                            startIcon={<Add />}
                            variant="contained"
                            color="primary"
                            disabled={
                              !(
                                formik.values.patient_id && patientName !== ''
                              ) || !formik.values.newExaminationType
                            }
                            onClick={() =>
                              addType(formik.values.newExaminationType)
                            }
                          >
                            Dodaj
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <div />
              )}

              {(formik.values.examinations[1] &&
                Object.keys(formik.values.examinations[1]).length !== 0) ||
              (formik.values.examinations[2] &&
                Object.keys(formik.values.examinations[2]).length !== 0) ||
              (formik.values.examinations[3] &&
                Object.keys(formik.values.examinations[3]).length !== 0) ||
              (formik.values.examinations[4] &&
                Object.keys(formik.values.examinations[4]).length !== 0) ? (
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {formik.values.examinations[1] &&
                      Object.keys(formik.values.examinations[1]).length !==
                        0 && (
                        <>
                          <Grid item xs={12}>
                            <Typography variant="subtitle1" component="div">
                              Badania Analogowe
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <ExaminationsTable
                              examinations={examinations}
                              formik={formik}
                              summarySkip={4}
                              type={1}
                              getFiles={getFiles}
                              handleChange={handleRowChange}
                              assignFileToComponent={assignFileToComponent}
                              deleteRow={deleteRow}
                              patient={formik.values.patient_id}
                              finalize={finalizeFlag}
                              edit={Boolean(id)}
                              internal={Boolean(formik.values.internal)}
                            />
                          </Grid>
                        </>
                      )}
                    {formik.values.examinations[2] &&
                      Object.keys(formik.values.examinations[2]).length !==
                        0 && (
                        <>
                          <Grid item xs={12}>
                            <Typography variant="subtitle1" component="div">
                              Badania Cyfrowe 2D
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <ExaminationsTable
                              examinations={examinations}
                              summarySkip={2}
                              formik={formik}
                              type={2}
                              getFiles={getFiles}
                              handleChange={handleRowChange}
                              assignFileToComponent={assignFileToComponent}
                              deleteRow={deleteRow}
                              editFile={editFile}
                              patient={formik.values.patient_id}
                              finalize={finalizeFlag}
                              edit={Boolean(id)}
                              internal={Boolean(formik.values.internal)}
                            />
                          </Grid>
                        </>
                      )}
                    {formik.values.examinations[3] &&
                      Object.keys(formik.values.examinations[3]).length !==
                        0 && (
                        <>
                          <Grid item xs={12}>
                            <Typography variant="subtitle1" component="div">
                              Badania Cyfrowe 3D
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <ExaminationsTable
                              examinations={examinations}
                              summarySkip={2}
                              formik={formik}
                              type={3}
                              getFiles={getFiles}
                              handleChange={handleRowChange}
                              assignFileToComponent={assignFileToComponent}
                              deleteRow={deleteRow}
                              editFile={editFile}
                              patient={formik.values.patient_id}
                              finalize={finalizeFlag}
                              edit={Boolean(id)}
                              internal={Boolean(formik.values.internal)}
                            />
                          </Grid>
                        </>
                      )}
                    {formik.values.examinations[4] &&
                      Object.keys(formik.values.examinations[4]).length !==
                        0 && (
                        <>
                          <Grid item xs={12}>
                            <Typography variant="subtitle1" component="div">
                              Badania Cyfrowe Punktowe
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <ExaminationsTable
                              examinations={examinations}
                              formik={formik}
                              summarySkip={4}
                              type={4}
                              getFiles={getFiles}
                              handleChange={handleRowChange}
                              assignFileToComponent={assignFileToComponent}
                              deleteRow={deleteRow}
                              patient={formik.values.patient_id}
                              finalize={finalizeFlag}
                              edit={Boolean(id)}
                              editFile={editFile}
                              internal={Boolean(formik.values.internal)}
                            />
                          </Grid>
                        </>
                      )}
                  </Grid>
                </Grid>
              ) : (
                validate && (
                  <Grid item xs={12}>
                    <Typography className={classes.error}>
                      Należy uwzględnić przynajmniej jedno badanie
                    </Typography>
                  </Grid>
                )
              )}
              {!id ||
                (!finalizeFlag && formik.values.status_id == 1 && (
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" component="div">
                          Dodaj usługę dodatkową
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item xs={4}>
                            <Button
                              startIcon={<Add />}
                              variant="contained"
                              color="primary"
                              disabled={
                                !(
                                  formik.values.patient_id && patientName !== ''
                                )
                              }
                              onClick={() => addExtra()}
                            >
                              Dodaj
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              {formik.values.extras &&
                Object.keys(formik.values.extras).length !== 0 && (
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1" component="div">
                          Usługi dodatkowe
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <ContractExtrasTable
                          extras={extras}
                          formik={formik}
                          handleChange={handleRowChange}
                          deleteRow={deleteExtraRow}
                          finalize={finalizeFlag}
                          edit={Boolean(id)}
                          internal={formik.values.internal}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                )}
            </Grid>
          </DialogContent>
          <DialogActions className={classes.footer_none}>
            <Grid
              container
              spacing={2}
              sx={{ justifyContent: 'flex-end', alignItems: 'center' }}
            >
              <Grid item>
                <Typography sx={{ fontWeight: 'bold' }}>Suma brutto</Typography>
                <Typography>
                  {summaryGross
                    ? Number(summaryGross)
                        .toFixed(2)
                        .toString()
                        .replace('.', ',')
                    : 0}{' '}
                  zł
                </Typography>
              </Grid>
              <Grid item>
                <LoadingButton
                  startIcon={<SaveIcon />}
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={() => setValidate(true)}
                  loading={loading}
                  loadingPosition="start"
                >
                  {events.length > 0 || Object.keys(eventsCount).length > 0
                    ? 'Zapisz i oznacz błędne zdjęcia'
                    : 'Zapisz'}
                </LoadingButton>
              </Grid>
            </Grid>
          </DialogActions>
          {/* @PATRYK  Tutaj jest komponent pytania, jest odpalany przez funkcje onsubmit w formiku, ktora odpala sie tylko kiedy walidacja przechodzi poprawnie */}
          {/* przy zaakceptowaniu komponent odpala to co bylo wczesniej w submicie, czyli wybiera czy to edit, store czy finalizacja i odpala odpowiednia funkcje */}
          {sweetAlert && (
            <Confirmation
              level={5}
              maxWidth="xs"
              icon="Warning"
              title={`Czy na pewno chcesz ${
                finalizeFlag ? 'sfinalizować' : 'dodać'
              } zlecenie`}
              subtitle={`Ta operacja nie jest odwracalna.`}
              reject={() => {
                setLoading(false)
                setSweetAlert(false)
              }}
              success={async () => {
                let elements = await document.querySelector('.Mui-error')
                if (!elements) {
                  let localValues = parseValues(
                    formik.values,
                    ourDoctor,
                    sweetAlert
                  )

                  if (!id || eventFlag) {
                    store(localValues)
                  } else if (id && finalizeFlag === true) {
                    finalize(localValues)
                  } else if (id && !finalizeFlag) {
                    edit(localValues)
                  }
                } else {
                  setLoading(false)
                }
              }}
            />
          )}
        </form>
      )}
    </>
  )
}

ContractFactory.propTypes = {
  values: PropTypes.object,
}

export default ContractFactory
